import { Component, OnInit } from "@angular/core";
import { PackersMoversService } from "../service/packers-movers.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-get-user-details",
  templateUrl: "./get-user-details.component.html",
  styleUrls: ["./get-user-details.component.sass"],
})
export class GetUserDetailsComponent implements OnInit {
  allRequirements: any[] = [];
  page = 1;
  limit = 10;
  totalCount = 0;
  totalPages = 0;
  isLoading = false;

  constructor(
    private packersMoversService: PackersMoversService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getUserRequirementsList();
  }

  getUserRequirementsList() {
    this.isLoading = true;

    const body = {
      page: this.page,
      limit: this.limit,
    };

    this.packersMoversService.getUserRequirementsList(body).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response.statusCode === 200) {
          this.allRequirements = response.data;
          this.totalCount = response.totalCount;
          this.totalPages = response.totalPages;
        }
      },
      (error) => {
        this.isLoading = false;
        console.log(error);
      },
    );
  }

  viewUserDetails(id: string) {
    this.router.navigate(["/dashboard/view-website-packers-movers-user"], {
      queryParams: { id },
    });
  }

  changePage(page: number) {
    this.page = page;
    this.getUserRequirementsList();
  }
}
